// extracted by mini-css-extract-plugin
export default {"Qualities":"Qualities_Qualities__aW42D","QualityList":"Qualities_QualityList__Fx9fP","QualitiesHeader":"Qualities_QualitiesHeader__lhU0X"};